import root from 'window-or-global';
import urlParse from 'url-parse';
import {getLocale} from './locale';

let defaultRoute = '/home';

export function setDefaultRoute(route: string) {
    defaultRoute = route;
}

export function getPlainPath() {
    // allow trailing slash in route match, http://website and http://website/
    let path = '/';
    if (root.appContext && root.appContext !== '' && root.appContext !== '/') {
        // set path to the defined context
        path = root.appContext;
    }
    return path;
}

export function getPath() {
    const plainPath = getPlainPath();
    const path = plainPath[plainPath.length - 1] === '/' ? plainPath : `${plainPath}/`;
    return path;
}

export function processPathname(url: string) {
    const locale = getLocale(); // en-US

    let urlWithLeadingSlash = url;
    if (url[0] !== '/') {
        urlWithLeadingSlash = `/${url}`;
    }
    //get the path from the url
    const fullUrl = urlParse(urlWithLeadingSlash, false);
    const queries = fullUrl.query;
    const hash = fullUrl.hash;

    let standardizedPath = fullUrl.pathname; // buy-now/battle-royale

    let context = getPlainPath(); // appContext i.e. /fortnite
    //add a leading slash if not present
    if (context[0] !== '/') {
        context = `/${context}`;
    }

    //remove trailing slash
    if (standardizedPath.length > 1 && standardizedPath[standardizedPath.length - 1] === '/') {
        standardizedPath = standardizedPath.substr(0, standardizedPath.length - 1) || '/';
    }

    // Strip off the context of requested route i.e. /home from /fortnite/home
    if (standardizedPath && standardizedPath.indexOf(context) === 0) {
        //cut the context out of the standardizedPath
        if (standardizedPath === context || standardizedPath.substr(0, context.length + 1) === `${context}/`) {
            standardizedPath = standardizedPath.substr(context.length) || '/';
        }
        //cut slash locale out of the standardizedPath
        if (standardizedPath.indexOf(`/${locale}/`) === 0 || standardizedPath === `/${locale}`) {
            standardizedPath = standardizedPath.substr(`/${locale}`.length) || '/';
        }
        //cut the locale out of the standardizedPath
        if (standardizedPath.indexOf(locale) === 0) {
            standardizedPath = standardizedPath.substr(locale.length) || '/';
        }
    }

    // Strip the leading / off the requested route (it is optional)
    let routePath = standardizedPath.indexOf('/') === 0 ? standardizedPath.substr(1) : standardizedPath;

    // append queryParams
    if (fullUrl && queries && queries.length) {
        const fullUrlStr = fullUrl.toString();
        if (fullUrlStr && fullUrlStr.length && fullUrlStr.indexOf('?') !== -1) {
            const parts = fullUrlStr.split('?');
            if (parts[1] && parts[1].length) {
                routePath += `?${parts[1]}`;
            }
        }
    }
    return `${routePath}${hash}`;
}

export function generateAppPath(name: string) {
    let pathName = name;
    if (!name || name === '/' || name === '') {
        pathName = defaultRoute;
    }
    const routePath = processPathname(pathName);
    const path = getPath();
    return `${path}${routePath}`;
}

export function generateRoutePath(name: string, dontIncludeLocale?: boolean) {
    if (dontIncludeLocale) return generateAppPath(name);
    let pathName = name;
    if (!name || name === '/' || name === '') {
        pathName = defaultRoute;
    }
    const routePath = processPathname(pathName);
    const locale = getLocale();
    const path = getPath();
    return `${path}${locale}/${routePath}`;
}
